import { NodeViewWrapper } from '@tiptap/react';
import { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player/lazy';
import axios from 'axios';

const UrlPasteBlock = ({ node, editor, getPos }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isVideoReady, setIsVideoReady] = useState(false);
  const embedRef = useRef(null);
  const URL = node?.attrs?.url || '';
  console.log({ node: node?.attrs?.url });

  let embeddedType = 'other';

  const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
  const iframePattern = /^<iframe.*?src="(.*?)".*?<\/iframe>/;  // Modified to match if the URL starts with <iframe>

  // First check if the URL contains <iframe>
  const isIframe = iframePattern.test(URL);

  if (isIframe) {
    embeddedType = 'iframe';
  } else if (URL?.trim()) {
    const youtubePattern = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/).+$/;
    const vimeoPattern = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/[^/]+\/videos\/|)(\d+)(?:\/)?(?:\?.*)?$/;
    const spotifyPattern = /^(https?:\/\/)?(open\.)?spotify\.com\/(track|album|playlist|artist)\/.+$/;
    const soundCloudPattern = /^(https?:\/\/)?(soundcloud\.com|snd\.sc)\/.+$/;
    const twitterPattern = /^(https?:\/\/)?(www\.)?twitter\.com\/.+\/status\/.+$/;
    const twitterXPattern = /^(https?:\/\/)?(www\.)?x\.com\/.+\/status\/.+$/;

    if (youtubePattern.test(URL) && urlPattern.test(URL)) {
      embeddedType = 'youtube';
    } else if (vimeoPattern.test(URL) && urlPattern.test(URL)) {
      embeddedType = 'vimeo';
    } else if (spotifyPattern.test(URL) && urlPattern.test(URL)) {
      embeddedType = 'spotify';
    } else if (soundCloudPattern.test(URL) && urlPattern.test(URL)) {
      embeddedType = 'soundCloud';
    } else if (twitterPattern.test(URL) || twitterXPattern.test(URL)) {
      embeddedType = 'twitter';
    }
  }

  console.log({ embeddedType });

  const handleVideoReady = () => {
    setIsVideoReady(true);
  };

  useEffect(() => {
    if (embeddedType === "other") {
      const url = node?.attrs?.url?.trim();
      getSiteData(url);
    }

    if (embeddedType === 'spotify' && embedRef.current) {
      setIsLoading(true);
      const spotifyId = URL.split('/').pop().split('?')[0];
      const embedHtml = `<iframe src="https://open.spotify.com/embed/${URL.split('/')[3]}/${spotifyId}?utm_source=generator&theme=0" width="100%" height="500" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`;
      embedRef.current.innerHTML = embedHtml;
      setIsLoading(false);
    }

    if (embeddedType === 'soundCloud' && embedRef.current) {
      setIsLoading(true);
      const embedHtml = `<iframe width="100%" height="170" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=${URL}&color=%231ED760&auto_play=true&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=false"></iframe>`;
      embedRef.current.innerHTML = embedHtml;
      setIsLoading(false);
    }

    if (embeddedType === 'twitter' && embedRef.current) {
      const tweetId = URL.split('/').pop();
      embedRef.current.innerHTML = ''; // Clear previous content before embedding

      const existingScript = document.querySelector('script[src="https://platform.twitter.com/widgets.js"]');
      const loadTwitterEmbed = () => {
        if (window.twttr) {
          window.twttr.widgets.createTweetEmbed(tweetId, embedRef.current)
            .catch(() => setErrorMessage("Data not found"));
        } else {
          setErrorMessage("Twitter widget not loaded");
        }
      };

      if (!existingScript) {
        const script = document.createElement('script');
        script.src = 'https://platform.twitter.com/widgets.js';
        script.async = true;
        script.onload = loadTwitterEmbed;
        document.body.appendChild(script);

        return () => {
          if (script) document.body.removeChild(script);
        };
      } else {
        loadTwitterEmbed();
      }
    }

    if (embeddedType === 'iframe' && embedRef.current) {
      setIsLoading(true);
      embedRef.current.innerHTML = URL; // Set the iframe HTML directly
      setIsLoading(false);
    }
  }, []);

  const getSiteData = async (url) => {
    try {
      setIsLoading(true);
      const urlData = { url };

      const response = await axios.post(
        `https://jourmal-node-dashboard.onrender.com/api/publicationurl/link`,
        urlData
      );

      if (response?.data?.previewData) {
        editor.chain().focus().setBookmarkBlock({
          title: response.data.previewData?.title || '',
          description: response.data.previewData?.description || '',
          imageUrl: response.data.previewData?.imageUrl || '',
          siteTitle: response.data.previewData?.siteTitle || '',
          favicon: response.data.previewData?.faviconSrc || '',
          url: node.attrs.url,
        }).run();
      }
    } catch (error) {
      console.error('Failed to fetch URL data:', error);
      setErrorMessage("No data found");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <NodeViewWrapper data-type={embeddedType} style={{margin:"20px 0"}}>
      {(embeddedType === 'youtube' || embeddedType === 'vimeo') &&
        <div className='video-wrapper youtube-video'>
          {!isVideoReady &&
            <div contentEditable={false} className="skeleton-video-wrapper"><div className="skeleton-video"></div></div>
          }
          <div contentEditable={false} className={isVideoReady ? 'player-wrapper player-ready' : 'player-wrapper'}>
            <ReactPlayer
              className='react-player'
              url={URL}
              width='100%'
              height='100%'
              controls
              onReady={handleVideoReady}
            />
          </div>
          <div className='video-title' contentEditable={false}>
            <p className={`video-caption`} contentEditable={true} ></p>
          </div>
        </div>
      }
      {
        (embeddedType === 'spotify' || embeddedType === "soundCloud" || embeddedType === "twitter" || embeddedType === "iframe") &&
        <div className={`${embeddedType}-node-wrapper`} data-type={embeddedType}>
          <div className={`${embeddedType}Embed`} ref={embedRef} />
        </div>
      }
      {
        (embeddedType === 'other') &&
        <div data-type='bookmark' className={`bookmark-node-wrapper ${isLoading && 'is-loading'}`} data-drag-handle>
          <label>
            <div className='urlInput'>
              {isLoading ? (
                <div className='linkbutton-loader loader-buttonHeight'>
                  <div className='ring-loader'></div>
                </div>
              ) : (
                <>
                  {errorMessage && <p className="error-message">{errorMessage}</p>}
                </>
              )}
            </div>
          </label>
        </div>
      }
    </NodeViewWrapper>
  );
};

export default UrlPasteBlock;
